<template>
  <div class="philly311 grid-container fluid pbxxl">
    <div class="grid-container">
      <h2 class="title ptl">
        Philly311
      </h2>
      <div class="grid-x">
        <div class="cell medium-12">
          <div class="subtitle">
            {{ $t("311.report-311") }}
          </div>
          <div class="buttons">
            <div>
              <a
                class="button content-type-featured mvm"
                href="https://www.phila.gov/services/property-lots-housing/submit-a-service-request-with-311/"
              >
                {{ $t("311.report-problem") }}
                <i
                  class="fas fa-angle-right fa-lg"
                  aria-hidden="true"
                />
              </a>
            </div>
            <div>
              <a
                class="button content-type-featured mvm"
                href="https://www.phila.gov/services/property-lots-housing/track-a-service-request-with-311/#/"
              >
                {{ $t("311.track-request") }}
                <i
                  class="fas fa-angle-right fa-lg"
                  aria-hidden="true"
                />
              </a>
            </div>                <div>
              <a
                class="button content-type-featured mvm"
                href="https://www.phila.gov/departments/philly311/"
              >
                {{ $t("311.ask-question") }}
                <i
                  class="fas fa-angle-right fa-lg"
                  aria-hidden="true"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
